(() => {
  const applyMaximumZoom = () => {
    const autoZoom = window.PeakStyleProductCardAutoZoom;
    if (autoZoom?.config) {
      autoZoom.config.maximumZoom = 3.2;
      autoZoom.refresh?.();
      return true;
    }
    return false;
  };

  if (!applyMaximumZoom()) {
    window.addEventListener('DOMContentLoaded', applyMaximumZoom, { once: true });
    window.addEventListener('load', applyMaximumZoom, { once: true });
  }
})();
